/**
 * Global search request (F6).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.11, PRD F6
 */
import type { SearchQuery, SearchResults } from '@nexus/contracts';

import { api } from '../../../lib/api-client';

export async function search(query: SearchQuery): Promise<SearchResults> {
  return api.get<SearchResults>('/search', { query });
}
